import React from 'react';
import { Bot } from 'lucide-react';
import { 
  getCallDirectionBadge, 
  getCallOutcomeBadge, 
  getSentimentBadge, 
  getLeadQualityBadge 
} from './utils';

/**
 * CallBadges - Renders all the badges for a call (direction, AI, outcome, sentiment, lead quality)
 */
const CallBadges = ({
  direction,
  isAIHandled,
  outcome,
  sentiment,
  leadQuality,
  className = ''
}) => {
  const directionBadge = getCallDirectionBadge(direction);
  const outcomeBadge = outcome ? getCallOutcomeBadge(outcome) : null;
  const sentimentBadge = sentiment ? getSentimentBadge(sentiment) : null;
  const leadBadge = leadQuality ? getLeadQualityBadge(leadQuality) : null;

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {/* Direction Badge */}
      <span className={`px-2 py-0.5 text-xs font-medium rounded-full border ${directionBadge.className}`}>
        {directionBadge.label}
      </span>

      {/* AI Handled Badge */}
      {isAIHandled && (
        <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-purple-500/20 text-purple-400 border border-purple-500/30 flex items-center gap-1">
          <Bot size={10} /> AI Handled
        </span>
      )}

      {/* Outcome Badge */}
      {outcomeBadge && (
        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${outcomeBadge.className}`}>
          {outcomeBadge.label}
        </span>
      )}

      {/* Sentiment Badge */}
      {sentimentBadge && (
        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${sentimentBadge.className}`}>
          {sentimentBadge.emoji} {sentiment}
        </span>
      )}

      {/* Lead Quality Badge */}
      {leadBadge && (
        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${leadBadge.className}`}>
          {leadBadge.label}
        </span>
      )}
    </div>
  );
};

export default CallBadges;
